/* eslint-disable  react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */

import { Button, Col, Divider, Form, Input, InputRef, Row, Select, Space } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { PlusOutlined, UserOutlined } from '@ant-design/icons';
import { store } from '~/store';
import { PlusIcon } from '~/img';
import colors from '~/constants/colors';
import { setPanelValueErr } from '~/slices/state';

function InputTreeElement(props: any) {
  const {
    item,
    ele,
    addElement,
    setCardholderModal,
    initialValue,
    productKey,
    isError,
    setIsError,
    form,
    allProductsLists,
  } = props;
  const [options, setoptions] = useState<any>([]);
  const [open, setOpen] = useState(false);
  // const selectRef: any = useRef();
  const inputRef = useRef<any>(null);
  const [inputValue, setInputValue] = useState<any>('');
  const isItdisabled = allProductsLists[productKey]?.filter((ele: any) => ele.type === item)?.length;

  function unique(arr: any, keyProps: any) {
    const kvArray = arr.map((entry: any) => {
      const key = keyProps.map((k: any) => entry[k]).join('|');
      return [key, entry];
    });
    const map = new Map(kvArray);
    return Array.from(map.values());
  }

  useEffect(() => {
    const sectionEntries = Object.entries(form?.getFieldsValue()[`${ele}-section`] || {})
      .flat()
      .slice(0, -1)
      .join('-');
    const selectOptions = Object.values(allProductsLists || {})
      ?.flat()
      ?.filter((item: any) => {
        const splitedItem = item.key?.split('-').slice(2, -1).join('-');
        return sectionEntries === splitedItem;
      })
      ?.map((dw: any) => {
        return {
          ...dw,
          title: dw?.name,
          label: (
            <span>
              {dw?.name} <PlusOutlined style={{ position: 'absolute', right: '10px', top: '30%' }} />
            </span>
          ),
          value: dw?.name,
        };
      });
    setoptions(unique(selectOptions, ['value']));
  }, [allProductsLists]);

  function addNodeHandler(item: any, ele: any) {
    if (item === 'cardholder') {
      setCardholderModal({ value: true, productKey });
    } else {
      const ErrorStatus = addElement(`${item}-section`, ele);
      setIsError(ErrorStatus);
    }
  }

  function checkAddHandler() {
    const test = form?.getFieldsValue();
    const emptyValues = Object.entries(test[`${item}-section`] || {})
      ?.filter(([key, value]: any) => {
        return !value;
      })
      .map(([key, value]: any) => key);
    if (emptyValues?.length) {
      store.dispatch(setPanelValueErr<any>({ sectionName: [`${item}-section`], keys: emptyValues }));
    } else {
      store.dispatch(setPanelValueErr<any>({ sectionName: [] }));
    }

    if (!emptyValues?.length || emptyValues?.includes(item)) {
      addNodeHandler(item, ele);
    }
  }

  return (
    <>
      <Row gutter={[10, 0]}>
        <Col>
          {item !== 'cardholder' && (
            <>
              <InputContainer>
                <Form.Item
                  style={{ marginTop: '-5px', padding: '0px', minWidth: '100px' }}
                  initialValue={initialValue}
                  name={[`${item}-section`, ele]}
                >
                  <Select
                    disabled={isItdisabled}
                    optionLabelProp=" "
                    id="selectDropdown"
                    onSelect={() => checkAddHandler()}
                    ref={inputRef}
                    open={open}
                    allowClear
                    style={{ height: '38px', paddingTop: '4px', width: 250 }}
                    onDropdownVisibleChange={(visible) => setOpen(visible)}
                    placeholder={`Add ${ele[0].toUpperCase()}${ele.slice(1)} Name`}
                    dropdownRender={(menu) => (
                      <>
                        <Row gutter={5} style={{ margin: '10px 10px 10px 10px' }}>
                          <Col span={20}>
                            <Input
                              onChange={(value) => {
                                setInputValue(value?.target?.value);
                              }}
                              style={{ height: '38px' }}
                              onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                  form.setFieldValue([`${item}-section`, ele], inputValue);
                                }
                              }}
                              value={inputValue}
                              key={`${productKey}-${item}-${ele}-Input`}
                              className="custom-input"
                              placeholder={`${ele[0].toUpperCase()}${ele.slice(1)} Name`}
                            />
                          </Col>
                          <Col span={4}>
                            <Button
                              style={{ width: '40px', height: '38px' }}
                              icon={<PlusOutlined />}
                              onClick={() => {
                                form.setFieldValue([`${item}-section`, ele], inputValue);
                                checkAddHandler();
                                setOpen(false);
                              }}
                            />
                          </Col>
                        </Row>
                        <Divider style={{ marginTop: '2px' }} />

                        {menu}
                      </>
                    )}
                    options={options}
                  />
                </Form.Item>
              </InputContainer>
              {isError?.value && (
                <p style={{ position: 'absolute', bottom: -12, width: '300px', color: colors.red[1100] }}>
                  {isError?.message}
                </p>
              )}
            </>
          )}
        </Col>
        {item === 'cardholder' && (
          <Col>
            <Form.Item>
              <Button
                onClick={() => {
                  checkAddHandler();
                }}
                htmlType="button"
                style={{ marginLeft: '-10px', backgroundColor: colors.blue[800] }}
                size="small"
                shape="circle"
                icon={<PlusIcon style={{ color: 'white', fontSize: '18px' }} />}
              />
            </Form.Item>
          </Col>
        )}
      </Row>
    </>
  );
}
const InputContainer = styled.div<any>`
  .ant-select-selector {
    border: 1px solid ${colors.blue[600]} !important;
  }
  .ant-select-selection-placeholder {
    color: ${colors.blue[400]};
  }
`;
export default InputTreeElement;
